var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ae",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00732f",
    d: "M0 0h512v170.7H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170.7h512v170.6H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 341.3h512V512H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h180v512H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAe);
export default __webpack_public_path__ + "static/media/ae.e982ce1a46db65259241bb5b37266864.svg";
export { ForwardRef as ReactComponent };